import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import AdditionalAssetToggleCard from "./AdditionalAssetToggleCard";
import ModalMedia from "../ModalMedia";
import { useTranslationApp } from "../../../lib/i18next";
import {
  SECTION_ADDITIONAL_ASSETS_TITLE,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_SUBTITLE,
  SECTION_ADDITIONAL_ASSETS_ASSET_LABEL,
  MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_EMPTY,
} from "../../../i18n/keysTranslations";

const AdditionalAssetsToggleSection = ({
  assets = [],
  enabledMap = {},
  onToggleAsset = () => {},
}) => {
  const { t } = useTranslationApp();
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);

  const onPreviewImage = ({ url }) => {
    if (!url) return;
    setPreviewImageUrl(url);
    setIsPreviewModalOpen(true);
  };

  const onClosePreviewModal = () => {
    setIsPreviewModalOpen(false);
    setPreviewImageUrl(null);
  };

  const getAssetLabel = (index) =>
    t(SECTION_ADDITIONAL_ASSETS_ASSET_LABEL, { number: index + 1 });

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CollectionsBookmarkOutlinedIcon
              sx={{ fontSize: 18, color: "text.secondary" }}
            />
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 600, color: "text.primary", lineHeight: 1.3 }}
            >
              {t(SECTION_ADDITIONAL_ASSETS_TITLE)}
            </Typography>
          </Box>
          <Typography
            variant="caption"
            sx={{ color: "text.secondary", display: "block" }}
          >
            {t(MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_SUBTITLE)}
          </Typography>
        </Box>

        {assets.length === 0 ? (
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontStyle: "italic",
              px: 0.5,
            }}
          >
            {t(MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_EMPTY)}
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              width: "100%",
            }}
          >
            {assets.map((asset, index) => (
              <AdditionalAssetToggleCard
                key={asset.urlImage || index}
                asset={asset}
                index={index}
                label={getAssetLabel(index)}
                isEnabled={enabledMap[index] !== false}
                onToggleAsset={onToggleAsset}
                onPreviewImage={onPreviewImage}
              />
            ))}
          </Box>
        )}
      </Box>

      {isPreviewModalOpen && (
        <ModalMedia
          modalOpen={isPreviewModalOpen}
          onCloseModal={onClosePreviewModal}
          url={previewImageUrl}
          showEditButton={false}
          showShareButton={false}
          showDownloadButton={true}
          showDeleteButton={false}
        />
      )}
    </>
  );
};

export default AdditionalAssetsToggleSection;
